var D = Object.defineProperty;
var l = (a, e) => D(a, "name", { value: e, configurable: !0 });
import { GraphQLNonNull as u, GraphQLList as f } from "graphql";
import { C as E } from "./codemirror.es.js";
import { g as N, a as T, b as g, c as h, d as C, e as p } from "./SchemaReference.es.js";
import "./info-addon.es.js";
import "./codemirror.es2.js";
import "./forEachState.es.js";
E.registerHelper("info", "graphql", (a, e) => {
  if (!e.schema || !a.state)
    return;
  const { kind: d, step: n } = a.state, r = N(e.schema, a.state);
  if (d === "Field" && n === 0 && r.fieldDef || d === "AliasedField" && n === 2 && r.fieldDef || d === "ObjectField" && n === 0 && r.fieldDef) {
    const i = document.createElement("div");
    i.className = "CodeMirror-info-header", M(i, r, e);
    const c = document.createElement("div");
    return c.append(i), o(c, e, r.fieldDef), c;
  }
  if (d === "Directive" && n === 1 && r.directiveDef) {
    const i = document.createElement("div");
    i.className = "CodeMirror-info-header", V(i, r, e);
    const c = document.createElement("div");
    return c.append(i), o(c, e, r.directiveDef), c;
  }
  if (d === "Argument" && n === 0 && r.argDef) {
    const i = document.createElement("div");
    i.className = "CodeMirror-info-header", x(i, r, e);
    const c = document.createElement("div");
    return c.append(i), o(c, e, r.argDef), c;
  }
  if (d === "EnumValue" && r.enumValue && r.enumValue.description) {
    const i = document.createElement("div");
    i.className = "CodeMirror-info-header", F(i, r, e);
    const c = document.createElement("div");
    return c.append(i), o(c, e, r.enumValue), c;
  }
  if (d === "NamedType" && r.type && r.type.description) {
    const i = document.createElement("div");
    i.className = "CodeMirror-info-header", m(i, r, e, r.type);
    const c = document.createElement("div");
    return c.append(i), o(c, e, r.type), c;
  }
});
function M(a, e, d) {
  y(a, e, d), v(a, e, d, e.type);
}
l(M, "renderField");
function y(a, e, d) {
  var n;
  const r = ((n = e.fieldDef) === null || n === void 0 ? void 0 : n.name) || "";
  t(a, r, "field-name", d, T(e));
}
l(y, "renderQualifiedField");
function V(a, e, d) {
  var n;
  const r = "@" + (((n = e.directiveDef) === null || n === void 0 ? void 0 : n.name) || "");
  t(a, r, "directive-name", d, g(e));
}
l(V, "renderDirective");
function x(a, e, d) {
  var n;
  const r = ((n = e.argDef) === null || n === void 0 ? void 0 : n.name) || "";
  t(a, r, "arg-name", d, h(e)), v(a, e, d, e.inputType);
}
l(x, "renderArg");
function F(a, e, d) {
  var n;
  const r = ((n = e.enumValue) === null || n === void 0 ? void 0 : n.name) || "";
  m(a, e, d, e.inputType), t(a, "."), t(a, r, "enum-value", d, C(e));
}
l(F, "renderEnumValue");
function v(a, e, d, n) {
  const r = document.createElement("span");
  r.className = "type-name-pill", n instanceof u ? (m(r, e, d, n.ofType), t(r, "!")) : n instanceof f ? (t(r, "["), m(r, e, d, n.ofType), t(r, "]")) : t(r, (n == null ? void 0 : n.name) || "", "type-name", d, p(e, n)), a.append(r);
}
l(v, "renderTypeAnnotation");
function m(a, e, d, n) {
  n instanceof u ? (m(a, e, d, n.ofType), t(a, "!")) : n instanceof f ? (t(a, "["), m(a, e, d, n.ofType), t(a, "]")) : t(a, (n == null ? void 0 : n.name) || "", "type-name", d, p(e, n));
}
l(m, "renderType");
function o(a, e, d) {
  const { description: n } = d;
  if (n) {
    const r = document.createElement("div");
    r.className = "info-description", e.renderDescription ? r.innerHTML = e.renderDescription(n) : r.append(document.createTextNode(n)), a.append(r);
  }
  L(a, e, d);
}
l(o, "renderDescription");
function L(a, e, d) {
  const n = d.deprecationReason;
  if (n) {
    const r = document.createElement("div");
    r.className = "info-deprecation", a.append(r);
    const i = document.createElement("span");
    i.className = "info-deprecation-label", i.append(document.createTextNode("Deprecated")), r.append(i);
    const c = document.createElement("div");
    c.className = "info-deprecation-reason", e.renderDescription ? c.innerHTML = e.renderDescription(n) : c.append(document.createTextNode(n)), r.append(c);
  }
}
l(L, "renderDeprecation");
function t(a, e, d = "", n = { onClick: null }, r = null) {
  if (d) {
    const { onClick: i } = n;
    let c;
    i ? (c = document.createElement("a"), c.href = "javascript:void 0", c.addEventListener("click", (s) => {
      s.preventDefault(), i(r, s);
    })) : c = document.createElement("span"), c.className = d, c.append(document.createTextNode(e)), a.append(c);
  } else
    a.append(document.createTextNode(e));
}
l(t, "text");
//# sourceMappingURL=info.es.js.map
